import { render, staticRenderFns } from "./AddCanned.vue?vue&type=template&id=c60f8ba8&scoped=true&"
import script from "./AddCanned.vue?vue&type=script&lang=js&"
export * from "./AddCanned.vue?vue&type=script&lang=js&"
import style0 from "./AddCanned.vue?vue&type=style&index=0&id=c60f8ba8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60f8ba8",
  null
  
)

export default component.exports